import {AbstractSliderQuestionType} from './abstract-slider-question-type';

export class EnergyLevelQuestionType extends AbstractSliderQuestionType {

  constructor() {
    super(false);
    this.name = 'energylevel';
    this.prettyName = 'Energielevel';
    this.icon = 'battery-half';
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/energy-level-question-type.ts